import React from "react";
import "./AddPetDetailsMobileView.css";
import PhotoIcon from "@mui/icons-material/Photo";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

function AddPetDetailsMobileView({ preview, activeForm, setActiveForm }) {
  const OpenPreviewForm = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}customerpost/UpdatePetOrderSummary`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

    } catch (error) {
      console.error("Error posting data:", error);
    }
    setActiveForm({
      customerDetails: false,
      relocationDetails: false,
      petDetails: false,
      preview: true,
      documentation: false,
    });
  };

  const baseAPI = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const [orderRelocation, setOrderRelocation] = useState([]);
  const [VaccinationBook_Front, setVaccinationBookFront] = useState(null);
  const [vaccinationBookBack, setVaccinationBookBack] = useState(null);
  const [petPhotosSitting, setPetPhotosSitting] = useState(null);
  const [petPhotosStanding, setPetPhotosStanding] = useState(null);
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    Number_Of_Pets: "",
    PetType: "",
    pet_Name: "",
    pet_breed: "",
    petbreedtype: "",
    pet_gender: "",
    Pet_Age: "",
    pet_behaviour: "",
    pet_color: "",
    Pet_Length: "",
    Pet_Height: "",
    Pet_Width: "",
    container_length: "",
    VaccinationBook_Front: "",
    VaccinationBook_Back: "",
    Pet_Photo_Sitting: "",
    Pet_Photo_Standing: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    
    setFirstItem((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderRelocation(response.data.data[0]);
          setFirstItem(response.data.data[0]);

          setVaccinationBookFront(
            `${baseImageURL}${response.data.data[0].VaccinationBook_Front}`
          );
          setVaccinationBookBack(
            `${baseImageURL}${response.data.data[0].VaccinationBook_Back}`
          );
          setPetPhotosSitting(
            `${baseImageURL}${response.data.data[0].Pet_Photo_Sitting}`
          );
          setPetPhotosStanding(
            `${baseImageURL}${response.data.data[0].Pet_Photo_Standing}`
          );
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    console.log(`Uploading file: ${file.name} for field: ${fieldName}`);

    uploadFile(file, fieldName);
  };

  const uploadFile = async (file, fieldName) => {
    const reader = new FileReader();

    reader.onload = async () => {
      const byteImg = reader.result;
      const mediaData = {
        type: "image",
        url: byteImg,
      };

      const storedToken = JSON.parse(localStorage.getItem("accessToken"));

      try {
        const response = await axios.post(
          `${baseAPI}customerpost/UploadImage`,
          mediaData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response && response.data) {
          setFirstItem((prevFirstItem) => ({
            ...prevFirstItem,
            [fieldName]: response.data.data,
          }));
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className="p-0">
      <div
        className="relocation-detail-main py-2 "
        style={{
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          backgroundColor: "white",
        }}
      >
        <div className="">
          <h1 className="heading" style={{ margin: "14px" }}>
            Pet Details
          </h1>
          {preview ? (
            <div
              style={{ paddingBottom: "0px" }}
              className="relocation-details-main-form px-4"
            >
              <div className="form-row row align-items-start">
              <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Owner's name on Vaccination Book
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    No. of Pets
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Number_Of_Pets}
                  </h4>
                </div>
                <div className="col-md-3 col-6 py-0 px-2 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Type
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.PetType}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Name
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.pet_Name}
                  </h4>
                </div>
                
              </div>

              <div className="form-row row align-items-start">
              <div className="col-md-3 col-6 py-0 px-2 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Breed
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.petbreedtype}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start p-0">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Gender
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.pet_gender === "1" ? "Male" : "Female"}
                  </h4>
                </div>
                <div className="col-md-3 col-6 py-0 px-2 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Age
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Pet_Age}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Behaviour
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.pet_behaviour}
                  </h4>
                </div>
                
              </div>

              <div className="form-row row align-items-start">
              <div className="col-md-3 col-6 py-0 px-2 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Colour
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.pet_color}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "29px",
                      paddingLeft: "2px",
                    }}
                  >
                    Pet Length (A)
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Pet_Length}
                  </h4>
                </div>
                <div className="col-md-3 col-6 py-0 px-2 text-start">
                  <h4
                    style={{
                      wordSpacing: "-1px",
                      fontSize: "13px",
                      color: "#6a6a6a",
                      marginTop: "29px",
                    }}
                  >
                    Pet Height From Ground To Elbow Joint (B)
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.container_length}
                  </h4>
                </div>
                <div className="col-md-3 col-6 p-0 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Width (C)
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Pet_Width}
                  </h4>
                </div>
                <div className="col-md-3 col-6 py-0 px-2 text-start">
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      marginTop: "20px",
                    }}
                  >
                    Pet Length (D)
                  </h4>
                  <h4
                    style={{
                      fontSize: "14px",
                      color: "#6a6a6a",
                      fontWeight: "700",
                    }}
                  >
                    {orderRelocation.Pet_Height}
                  </h4>
                </div>
              </div>
            </div>
          ) : (
            <form className="relocation-details-main-form mt-0">
              <div className="form-row mt-0  row align-items-center">
              <div className="col-12" style={{}}>
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Owner's name on Vaccination Book
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    // name="pet_behaviour"
                    // value={firstItem.pet_behaviour}
                    // onChange={handleChange1}
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    No. of Pets
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.Number_Of_Pets}
                    disabled
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Type
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.PetType}
                    disabled
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Name
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.pet_Name}
                    disabled
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Breed
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.petbreedtype}
                    disabled
                  />
                </div>
              </div>
              <div className="form-row row align-items-center">
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Gender
                  </label>
                  <select
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    className="form-select m-0"
                    aria-label="Default select example"
                    name="pet_gender"
                    value={firstItem.pet_gender}
                    onChange={handleChange1}
                  >
                    <option selected>Select an option</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                  </select>
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Age
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.Pet_Age}
                    disabled
                  />
                </div>
                <div className="col-12" style={{}}>
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Behaviour
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="pet_behaviour"
                    value={firstItem.pet_behaviour}
                    onChange={handleChange1}
                  />
                </div>
              </div>
              <div className="form-row mt-0  row align-items-center">
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Color
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="pet_color"
                    value={firstItem.pet_color}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Length (A)
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.Pet_Length}
                    disabled
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{
                      color: "#6a6a6a",
                      marginTop: "29px",
                      fontSize: "13px",
                      wordSpacing: "-1px",
                    }}
                    className=""
                    htmlFor=""
                  >
                    Pet Height From Ground To Elbow Joint (B)
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.container_length}
                    disabled
                  />
                </div>
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Width (C)
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.Pet_Width}
                    disabled
                  />
                </div>
              </div>
              <div className="form-row mt-0  row align-items-center">
                <div className="col-6">
                  <label
                    style={{ color: "#6a6a6a", marginTop: "29px" }}
                    className=""
                    htmlFor=""
                  >
                    Pet Height (D)
                  </label>
                  <input
                    style={{
                      border: preview ? "none" : "1px solid #5B489D",
                      paddingLeft: preview ? "0px" : "10px",
                      fontWeight: preview ? "bold" : "",
                      width: "100%",
                      fontSize: "14px",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    value={firstItem.Pet_Height}
                    disabled
                  />
                </div>
              </div>
            </form>
          )}
        </div>{" "}
        <div
          className="p-3 "
          style={{
            marginTop: "21px",
          }}
        >
          <h1
            style={{
              paddingLeft: "10px",
              paddingRight: "0px",
              marginLeft: "1px",
              marginRight: "1px",
            }}
            className="heading"
          >
            Pet Related Pictures
          </h1>
          <form style={{ marginTop: "21px" }} className="pet-detail-main-form">
            <div className="form-row row text-center">
              <div style={{ position: "relative" }}>
                <h5
                  className="text-start"
                  style={{
                    fontSize: "12px",
                    position: "absolute",
                    top: "-7px",
                    backgroundColor: "white",
                    zIndex: "1",
                  }}
                >
                  Vaccination Book
                </h5>
              </div>
              <div
                style={{
                  border: "3px solid rgb(229 225 225)",
                  marginRight: "0px",
                  borderRadius: "8px",
                }}
                className="col-12 p-0 d-flex justify-content-between align-items-center"
              >
                <div className="p-2" style={{ flex: 1 }}>
                  {firstItem.VaccinationBook_Front &&
                  firstItem.VaccinationBook_Front.trim() !== "" ? (
                    <img
                      alt="Vaccination Book Front"
                      src={VaccinationBook_Front}
                      style={{ color: "#6a6a6a",height:"184px" }}
                      className=""
                    />
                  ) : (
                    <label
                      style={{ color: "#6a6a6a", height: "184px" }}
                      className=""
                      htmlFor="vaccinationBook1"
                    >
                      <PhotoIcon />
                    </label>
                  )}
                  <input
                    id="vaccinationBook1"
                    style={{ border: "1px solid #5B489D", width: "100%" }}
                    type="file"
                    className="form-control m-0"
                    name="VaccinationBook_Front"
                    onChange={handleFileChange}
                  />
                </div>

                <div
                  className="text-center"
                  style={{ flex: 1, paddingRight: "7px" }}
                >
                  {firstItem.VaccinationBook_Back &&
                  firstItem.VaccinationBook_Back.trim() !== "" ? (
                    <img
                      alt="Vaccination Book Back"
                      src={vaccinationBookBack}
                      style={{ color: "#6a6a6a" ,height:"184px"}}
                      className=""
                    />
                  ) : (
                    <label
                      style={{ color: "#6a6a6a", height: "184px" }}
                      className=""
                      htmlFor="vaccinationBook2"
                    >
                      <PhotoIcon />
                    </label>
                  )}
                  <input
                    id="vaccinationBook2"
                    style={{ border: "1px solid #5B489D", width: "100%" }}
                    type="file"
                    className="form-control m-0"
                    name="VaccinationBook_Back"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>
            <div className="form-row row text-center mt-4 ">
              <div style={{ position: "relative" }}>
                <h5
                  className="text-start"
                  style={{
                    fontSize: "12px",
                    position: "absolute",
                    top: "-7px",
                    backgroundColor: "white",
                    zIndex: "1",
                  }}
                >
                  Pet Photos
                </h5>
              </div>
              <div
                style={{
                  border: "3px solid rgb(229 225 225)",
                  borderRadius: "8px",
                  marginRight: "0px",
                }}
                className="col-12 p-0 d-flex justify-content-between align-items-center"
              >
                <div className="p-2" style={{ flex: 1 }}>
                  {firstItem.Pet_Photo_Sitting &&
                  firstItem.Pet_Photo_Sitting.trim() !== "" ? (
                    <img
                      alt="Pet Sitting"
                      src={petPhotosSitting}
                      style={{ color: "#6a6a6a" ,height:"184px"}}
                    />
                  ) : (
                    <label
                      style={{ color: "#6a6a6a", height: "184px" }}
                      className=""
                      htmlFor="vaccinationBook1"
                    >
                      <PhotoIcon />
                    </label>
                  )}
                  <input
                    id="vaccinationBook1"
                    style={{ border: "1px solid #5B489D", width: "100%" }}
                    type="file"
                    className="form-control m-0"
                    name="Pet_Photo_Sitting"
                    onChange={handleFileChange}
                  />
                </div>

                <div
                  className="text-center"
                  style={{ flex: 1, paddingRight: "7px" }}
                >
                 {firstItem.Pet_Photo_Standing &&
                    firstItem.Pet_Photo_Standing.trim() !== "" ? (
                      <img
                        alt="Pet Standing"
                        src={petPhotosStanding}
                        style={{ color: "#6a6a6a" ,height:"184px"}}
                      />
                    ) : (
                  <label
                    style={{ color: "#6a6a6a", height: "184px" }}
                    className=""
                    htmlFor="vaccinationBook2"
                  >
                    <PhotoIcon />
                  </label>
                )}
                  <input
                    id="vaccinationBook2"
                    style={{ border: "1px solid #5B489D", width: "100%" }}
                    type="file"
                    className="form-control m-0"
                    name="Pet_Photo_Standing"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>
            {preview ? null : (
              <>
                <hr style={{ marginTop: "46px" }} />
                <div
                  style={{ textAlign: "end" }}
                  className="form-button-div mt-3 px-1"
                >
                  <button
                    onClick={OpenPreviewForm}
                    style={{
                      paddingBottom: "5px",
                      width: "150px",
                      fontSize: "14px",
                    }}
                    type="submit"
                    className="btn"
                  >
                    SAVE & NEXT <span style={{ fontSize: "20px" }}>&rarr;</span>
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddPetDetailsMobileView;
